<template>
  <div class="about">
    <p>Jeszcze nic ...</p>
  </div>
</template>
<style scoped>
  @import url(https://fonts.googleapis.com/css?family=Righteous);

*, *:before, *:after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  position: relative;
  }

html, body {
  height: 100%;
  }
  body {
    text-align: center;
    background-color: rgb(125, 123, 231);
    }
  body:before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    font-size: 0;
    height: 100%;
    }

p {
  display: inline-block;
  color: rgb(211, 211, 211);
  font-family: 'Righteous', serif;
  font-size: 2em; 
  text-shadow: .10em .10em .10em rgb(175, 39, 39);
  }
  h1:after {
    content: attr(data-shadow);
    position: absolute;
    top: .06em; left: .06em;
    z-index: -1;
    text-shadow:cornsilk;
    background-image:
      linear-gradient(
        45deg,
        transparent 45%,
        hsla(48,20%,90%,1) 45%,
        hsla(48,20%,90%,1) 55%,
        transparent 0
        );
    background-size: .05em .05em;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  
    animation: shad-anim 15s linear infinite;
    }

@keyframes shad-anim {
  10% {background-position: 0 0}
  10% {background-position: 100% -100%}
  
}
</style>